/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import ictLogo from '../../assets/images/ICT-Logo-V4-1-1 1 (1).png';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { baseURL } from '../../Config';
import Filter from '../../assets/icons/Filter.svg';
import PermitViewSideBar from '../Permit/PermitViewSideBar';
import { OverlayPanel } from 'primereact/overlaypanel';
import ViewReport from './ViewReport';
import SuccessLoader from '../../components/SuccessLoader';
import { handlePostRequest } from '../../services/PostTemplate';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

function ReportManagement() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const menuRefs = useRef(new Map());
    const toast = useRef(null);
    const filterOverlayRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState();
    const [showSuccess, setShowSuccess] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [searchFilters, setSearchFilters] = useState({
        vehicleNumber: null,
        cfxNumber: null,
        startDate: null,
        endDate: null,
        permitNumber: null,
        vehicleTypeId: null,
        paymentMethodId: null,
        requestStatusId: null
    });
    const [vehivleList, setVehicleList] = useState();
    const [methodList, setMethodList] = useState();
    const [statusList, setStatusList] = useState();


    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const filterOptions = [
        { name: '', label: 'All Reports', bgColor: '#3434341F' },
        { name: 'Pending', label: 'Pending Applications', bgColor: '#ACA9FF1F' },
        { name: 'Approved', label: 'Approved Applications', bgColor: '#3A974C1F' },
        { name: 'Rejected', label: 'Rejected Applications', bgColor: '#FF556A1F' }
    ];

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const handleFilterSelect = (filter) => {
        setSelectedFilter(filter.name);
        filterOverlayRef.current.hide();
    };

    // useEffect(() => {
    //     if (selectedFilter === '') {
    //         fetchReportData(page);
    //     } else {
    //         fetchReportData(page, selectedFilter);
    //     }
    // }, [selectedFilter]);

    const fetchReportData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            // Format dates properly
            const formatDate = (date) => {
                if (!date) return null;
                if (typeof date === 'string') return date;
                return date instanceof Date ?
                    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` :
                    null;
            };

            // Get current date for default end date
            const today = new Date();
            const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

            // Default start date if not provided by user
            const DEFAULT_START_DATE = "2020-02-01";

            // Use defaults if dates not selected
            const startDate = searchFilters.startDate ? formatDate(searchFilters.startDate) : DEFAULT_START_DATE;
            const endDate = searchFilters.endDate ? formatDate(searchFilters.endDate) : currentDate;

            // Build the request body with proper null handling for empty values
            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: searchFilters.vehicleNumber && searchFilters.vehicleNumber.trim() !== '' ? searchFilters.vehicleNumber : null,
                vehicleTypeId: searchFilters.vehicleTypeId === 0 ? 0 : (searchFilters.vehicleTypeId || null),
                paymentMethodId: searchFilters.paymentMethodId === 0 ? 0 : (searchFilters.paymentMethodId || null),
                permitNumber: searchFilters.permitNumber && searchFilters.permitNumber.trim() !== '' ? searchFilters.permitNumber : null,
                cfxNumber: searchFilters.cfxNumber && searchFilters.cfxNumber.trim() !== '' ? searchFilters.cfxNumber : null,
                startDate: startDate,
                endDate: endDate,
                requestStatusId: searchFilters.requestStatusId === 0 ? 0 : (searchFilters.requestStatusId || null)
            };

            const response = await dispatch(handlePostRequest(
                requestBody,
                '/api/permit/get',
                false,
                false
            ));

            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            } else {
                // Handle no results scenario
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
            // Reset table in case of error
            setTableData([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };


    // useEffect(() => {
    //     fetchReportData(page);
    // }, []);

    const getStatusSeverity = (status) => {
        switch (status) {
            case 'Pending':
                return 'info';
            case 'Approved':
                return 'success';
            case 'Rejected':
                return 'danger';
            case 'Completed':
                return 'warning';
            default:
                return 'info';
        }
    };

    const getPaymentStatusSeverity = (status) => {
        switch (status) {
            case 'Cash In Hand':
                return 'warning';
            case 'Paid By Client':
                return 'info';
            case 'Paid By Officer':
                return 'success';
            default:
                return 'info';
        }
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.status} severity={getStatusSeverity(rowData.status)} />;
    };

    const paymentStatusBodyTemplate = (rowData) => {
        return <Tag value={rowData.paymentStatus} severity={getPaymentStatusSeverity(rowData.paymentStatus)} />;
    };

    const onHideSidebar = () => {
        setSidebarVisible(false);
        setIsEditing(false);
        setEditData(null);
        setEditAble(false);
    };

    const handleView = (rowData) => {
        setEditData(rowData?.id);
        setSidebarVisible(true);
    };

    const actionBodyTemplate = (rowData) => {
        const items = [
            {
                label: 'View',
                icon: 'pi pi-eye',
                className: 'custom-view',
                command: () => handleView(rowData)
            }
        ];

        if (!menuRefs.current.has(rowData.id)) {
            menuRefs.current.set(rowData.id, React.createRef());
        }
        const rowMenuRef = menuRefs.current.get(rowData.id);

        return (
            <div>
                <Menu model={items} popup ref={rowMenuRef} />
                <Button
                    icon="pi pi-ellipsis-h"
                    className="p-button p-0 m-0 bg-white border-none shadow-none hover:bg-gray-100 custom-icon-black"
                    style={{ boxShadow: 'none' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        rowMenuRef.current.toggle(e);
                    }}
                />
            </div>
        );
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> data
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

    const handleExport = async () => {
        try {
            const response = await fetch(`${baseURL}/api/report/permit/excel`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`
                },
                body: JSON.stringify(searchFilters)
            });

            if (!response.ok) {
                throw new Error('Export failed');
            }

            const contentDisposition = response.headers.get('Content-Disposition');
            const filename = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : `PermitRequests_${new Date().toISOString().slice(0, 10)}.xlsx`;

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Report exported successfully',
                life: 3000
            });
        } catch (error) {
            console.error('Export error:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to export report',
                life: 3000
            });
        }
    };


    const renderHeader = () => {
        return (
            <div className="Global__Header">
                <h5 className="m-0">Report List</h5>
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..." style={{ color: '#000' }} />
                </span>
            </div>
        );
    };
    const header = () => renderHeader();

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        fetchReportData(newPage);
    };
    const getLovsData = async () => {
        const vehiclesData = await handleGetRequest('/api/dropdown/vehicles', false);
        if (vehiclesData?.success) {
            setVehicleList(vehiclesData?.data);
        }
        const methodsData = await handleGetRequest('/api/dropdown/payment/method', false);
        if (methodsData?.success) {
            setMethodList(methodsData?.data);
        }
        const statusData = await handleGetRequest('/api/dropdown/request/status', false);
        if (statusData?.success) {
            setStatusList(statusData?.data);
        }
    };

    useEffect(() => {
        getLovsData();
    }, []);

    const handleSearchFilterChange = (field, value) => {
        setSearchFilters((prev) => ({
            ...prev,
            [field]: value
        }));
    };
    const handleSearch = () => {
        setPage(1);
        setFirst(0);
        fetchReportData(1);
    };

    const handleClearSearch = () => {
        setSearchFilters({
            vehicleNumber: null,
            cfxNumber: null,
            vehicleTypeId: null,
            startDate: null,
            endDate: null,
            permitNumber: null,
            paymentMethodId: null,
            requestStatusId: null
        });
        setPage(1);
        setFirst(0);
        fetchReportData(1);
    };

    return (
        <>
            {showSuccess && <SuccessLoader />}
            <Toast ref={toast} />
            <div className="grid">
                <div className="col-12 flex flex-column">
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Report Management</h2>
                        <div className="flex items-center gap-2">
                            {/* <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                            </span> */}
                            <Button
                                label="Export Report"
                                className="px-4 py-2 font-semibold"
                                style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px' }}
                                onClick={handleExport}
                            />
                            {/* <div className="relative">
                                <Button
                                    label="Filters"
                                    icon={<img src={Filter} alt="Filter" className="w-[18px] h-[18px]" />}
                                    iconPos="right"
                                    className="px-4 py-2 font-[14px] font-semibold flex align-items-center gap-2"
                                    style={{ backgroundColor: '#FFF', color: '#FF556A', border: '1px solid #FF556A', borderRadius: '10px' }}
                                    onClick={(e) => filterOverlayRef.current.toggle(e)}
                                />
                                <OverlayPanel
                                    ref={filterOverlayRef}
                                    className="filter-overlay"
                                    showCloseIcon={false}
                                    dismissable={true}
                                    style={{
                                        padding: '1rem',
                                        border: 'none',
                                        borderRadius: '12px',
                                        // boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor: '#FFF',
                                        width: '391px'
                                    }}
                                    breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                                >
                                    <div className="flex justify-content-between align-items-center mb-3">
                                        <span className="font-semibold text-[16px]">Filters</span>
                                        <Button
                                            label="Reset"
                                            icon="pi pi-times"
                                            style={{ backgroundColor: 'transparent', border: 'none', color: '#6C757D' }}
                                            onClick={() => {
                                                handleFilterSelect(filterOptions[0]);
                                                filterOverlayRef.current.hide();
                                            }}
                                        />
                                    </div>
                                    <div className="flex flex-column gap-2">
                                        {filterOptions.map((filter, index) => (
                                            <Button
                                                key={index}
                                                label={filter.label}
                                                className="w-full text-left justify-content-start font-normal"
                                                style={{
                                                    backgroundColor: filter.bgColor,
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    color: '#333',
                                                    padding: '0.5rem 1rem',
                                                    margin: '0.1rem 0',
                                                    width: '343.47px',
                                                    height: '40px'
                                                }}
                                                onClick={() => handleFilterSelect(filter)}
                                            />
                                        ))}
                                    </div>
                                </OverlayPanel>
                            </div> */}
                        </div>
                    </div>
                    <div className="mt-3 p-3 border-1 surface-border border-round">
                        <div className="grid">
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">

                                    <InputText id="vehicleNumber" value={searchFilters.vehicleNumber} onChange={(e) => handleSearchFilterChange('vehicleNumber', e.target.value)} placeholder="Enter vehicle number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">

                                    <InputText id="cfxNumber" value={searchFilters.cfxNumber} onChange={(e) => handleSearchFilterChange('cfxNumber', e.target.value)} placeholder="Enter CFX number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">

                                    <InputText id="permitNumber" name="permitNumber" value={searchFilters.permitNumber} onChange={(e) => handleSearchFilterChange('permitNumber', e.target.value)} placeholder="Enter permit number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={vehivleList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="vehicleTypeId"
                                        name="vehicleTypeId"
                                        value={searchFilters.vehicleTypeId}
                                        onChange={(e) => handleSearchFilterChange('vehicleTypeId', e.target.value)}
                                        placeholder="Select Vehicle Category"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={methodList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="paymentMethodId"
                                        value={searchFilters.paymentMethodId}
                                        onChange={(e) => handleSearchFilterChange('paymentMethodId', e.target.value)}
                                        placeholder="Select Payment Method"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={statusList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="requestStatusId"
                                        value={searchFilters.requestStatusId}
                                        onChange={(e) => handleSearchFilterChange('requestStatusId', e.target.value)}
                                        placeholder="Select Status"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <Calendar
                                    id="startDate"
                                    name="startDate"
                                    placeholder="Select start date"
                                    dateFormat="mm/dd/yy"
                                    value={searchFilters.startDate}
                                    onChange={(e) => {
                                        handleSearchFilterChange('startDate', e.value);
                                        // If end date is before new start date, reset end date
                                        if (searchFilters.endDate && e.value && searchFilters.endDate < e.value) {
                                            handleSearchFilterChange('endDate', null);
                                        }
                                    }}
                                    inputClassName="Input__Round"
                                />
                            </div>
                            <div className="col-12 md:col-3">
                                <Calendar
                                    id="endDate"
                                    name="endDate"
                                    placeholder="Select end date"
                                    dateFormat="mm/dd/yy"
                                    value={searchFilters.endDate}
                                    onChange={(e) => handleSearchFilterChange('endDate', e.value)}
                                    minDate={searchFilters.startDate || undefined}
                                    inputClassName="Input__Round"
                                />
                            </div>
                        </div>
                        <div className="flex justify-content-end gap-2 mt-3">
                            <Button label="Search" icon="pi pi-search" className="px-4 py-2 font-semibold" style={{ backgroundColor: '#ff556a', border: 'none', borderRadius: '10px' }} onClick={handleSearch} />
                            <Button label="Clear" icon="pi pi-times" className="px-4 py-2 font-semibold" style={{ borderRadius: '10px', backgroundColor: '#ff556a', border: 'none' }} onClick={handleClearSearch} />
                        </div>
                    </div>
                    <div className="card mt-3">
                        <DataTable
                            value={tableData}
                            globalFilterFields={['regNum', 'vehicleType', 'permitNum', 'fitnessCFX', 'requestDate', 'requestStatus', 'paymentMethod', 'totalAmount']}
                            filters={filters}
                            filterDisplay="menu"
                            className="datatable-responsive shadow-md rounded-xl sticky-header-table"
                            responsiveLayout="scroll"
                            loading={loading}
                            scrollable
                            scrollHeight="300px"
                            stickyHeader
                            emptyMessage={
                                <div className="w-full text-center">
                                    No results found
                                </div>
                            }
                        >
                            {/* <Column field="id" header="Request ID" sortable /> */}
                            <Column field="regNum" header="Reg No." />
                            <Column field="vehicleType" header="Vehicle Category" />
                            <Column field="permitNum" header="Permit Number" />
                            <Column field="fitnessCFX" header="Fitness CFX" />
                            <Column field="requestDate" header="Request Date" align="center" />
                            <Column
                                field="requestStatus"
                                header="Request Status"
                                align="center"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${rowData.requestStatus === 'Approved'
                                                ? 'bg-[#E6F4EA] text-[#3A974C] Active-column'
                                                : rowData.requestStatus === 'Pending'
                                                    ? 'bg-[#FFEFE9] text-[#FFEFE9] Inactive-column-cc'
                                                    : rowData.requestStatus === 'Rejected'
                                                        ? 'bg-[##FFFFE0] text-[#FF8F6B] Inactive-column'
                                                        : ''
                                            }`}
                                    >
                                        {rowData.requestStatus}
                                    </div>
                                )}
                            />
                            <Column field="totalAmount" header="Total Amount" align="center" />
                            <Column
                                field="paymentMethod"
                                header="Payment Method"
                                align="center"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${rowData.paymentMethod === 'Paid By Client'
                                                ? 'bg-[#E6F4EA] text-[#3A974C] Active-column'
                                                : rowData.paymentMethod === 'Paid By Officer'
                                                    ? 'bg-[#FFEFE9] text-[#FFEFE9] Inactive-column-cc'
                                                    : rowData.paymentMethod === 'Cash In Hand'
                                                        ? 'bg-[##FFFFE0] text-[#FF8F6B] Inactive-column'
                                                        : ''
                                            }`}
                                    >
                                        {rowData.paymentMethod}
                                    </div>
                                )}
                            />
                            {/* Custom Payment Status Column */}
                            <Column
                                field="paymentStatus"
                                header="Payment Status"
                                align="center"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${rowData.paymentStatus === 'Paid'
                                                ? 'bg-[#E6F4EA] text-[#3A974C] Active-column'
                                                : rowData.paymentStatus === 'UnPaid'
                                                    ? 'bg-[#FFEFE9] text-[#FF8F6B] Inactive-column'
                                                    : ''
                                            }`}
                                    >
                                        {rowData.paymentStatus}
                                    </div>
                                )}
                            />
                            <Column body={actionBodyTemplate} style={{ width: '4rem' }} />
                        </DataTable>
                        <div className="flex justify-content-between mt-1" style={{ borderTop: '1px solid #efefef' }}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>

            <Sidebar
                className="p-sidebar-md renewal-sidebar"
                visible={sidebarVisible}
                position="right"
                onHide={onHideSidebar}
                style={{ width: '581px' }}
                pt={{
                    header: { className: 'border-bottom-1' },
                    content: { className: 'p-0' }
                }}
                showCloseIcon={false}
                blockScroll={true}
            >
                <PermitViewSideBar onHideSidebar={onHideSidebar} editData={editData} onActionPerformed={() => fetchReportData(page)} />
            </Sidebar>

            <style jsx>{`
                .filter-overlay .p-button:hover {
                    filter: brightness(0.95);
                }
                .filter-overlay {
                    min-width: 250px;
                }
                .sticky-header-table .p-datatable-thead {
                    position: sticky;
                    top: 0;
                    z-index: 1;
                }
                .sticky-header-table .p-datatable-thead > tr > th {
                    background-color: white;
                    position: sticky;
                    top: 0;
                    z-index: 1;
                    border-top: 0;
                }
            `}</style>
        </>
    );
}

export default ReportManagement;
